import React, { useEffect, useState } from 'react';
import EditableText from '../../../../../EditableText/EditableText';
import EditableReportSections from '../../constants/EditableReportSections';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './style/editableadvice.scss';

const SelectionAdviceScore = {
    NEGATIVE: 'negative',
    TENTATIVE: 'tentative',
    POSITIVE: 'positive'
};

export const EditableAdvice = ({
    saveReportText,
    isFinalized,
    textEditable,
    allowedToEditReflection,
    section,
    saveInterval,
    saveAdviceOutcome,
    i18n,
    storedAdviceOutcome,
    showAdviceSelection
}) => {
    const [showSelectionAdviceModal, setShowSelectionAdviceModal] = useState(false);
    const [adviceOutcome, setAdviceOutcome] = useState(null);

    const toggleSelectionAdviceModal = () => {
        setShowSelectionAdviceModal(!showSelectionAdviceModal);
    };

    const getTranslatedAdvice = adviceHandle => (i18n && i18n[`report_selection_advice_${adviceHandle}`]) || adviceHandle;

    // populate once stored value comes in
    useEffect(() => {
        if (storedAdviceOutcome && (storedAdviceOutcome !== adviceOutcome)) {
            setAdviceOutcome(storedAdviceOutcome);
        }
    }, [storedAdviceOutcome]);

    return <div className={style.editableAdvice}>
        { showAdviceSelection && <section className={style.adviceSection}>
            <figure className={adviceOutcome && style[adviceOutcome.toString()]} />
            <span role="button" tabIndex={1} onClick={ () => toggleSelectionAdviceModal() }>
                {adviceOutcome ? getTranslatedAdvice(adviceOutcome) : i18n?.report_selection_advice_select_advice}
                <FontAwesomeIcon icon={'caret-down'} />
            </span>
            <div className={`${style.selectionAdviceModal} ${showSelectionAdviceModal ? '' : 'hidden'}`}>
                <ul
                    onClick={event => {
                        saveAdviceOutcome(event.target.id);
                        setAdviceOutcome(event.target.id);
                        toggleSelectionAdviceModal();
                    }}
                >
                    {Object.values(SelectionAdviceScore).map(scoreValue =>
                        <li key={scoreValue} id={scoreValue} className={adviceOutcome === scoreValue ? style.selected : ''}>
                            {i18n && i18n[`report_selection_advice_${scoreValue}`]}
                        </li>)}
                </ul>
            </div>
        </section>
        }
        <section className={style.explanationSection}>
            {(section.handle === EditableReportSections.SELECTION_ADVICE || section.handle === EditableReportSections.SELECTION_DEVELOPMENT_ADVICE) &&
                <>
                    {section.handle === EditableReportSections.SELECTION_DEVELOPMENT_ADVICE &&
                        <h4 className={style.helperText}>{i18n.report_selection_development_advice_selection_text_header}</h4>}
                    <div className={style.editableTextWrapper}>
                        <EditableText
                            saveReportText={saveReportText}
                            isFinalized={isFinalized}
                            textEditable={textEditable}
                            allowedToEditReflection={allowedToEditReflection}
                            templateSlug={section.handle}
                            id={`${section.handle}-selectionAdvice`}
                            slug={section.handle}
                            name={'selectionAdvice'}
                            text={section.text || section.selectionText}
                            saveInterval={saveInterval}
                            textareaPlaceholderText={i18n.report_edit_selection_development_advice_selection_text_placeholder}
                        />
                    </div>
                </>
            }
            {(section.handle === EditableReportSections.SELECTION_DEVELOPMENT_ADVICE || section.handle === EditableReportSections.DEVELOPMENT_ADVICE) &&
                <>
                    {section.handle === EditableReportSections.SELECTION_DEVELOPMENT_ADVICE &&
                        <h4 className={style.helperText}>{i18n.report_selection_development_advice_development_text_header}</h4>}
                    <div className={style.editableTextWrapper}>
                        <EditableText
                            saveReportText={saveReportText}
                            isFinalized={isFinalized}
                            textEditable={textEditable}
                            allowedToEditReflection={allowedToEditReflection}
                            templateSlug={section.handle}
                            id={`${section.handle}-developmentAdvice`}
                            slug={section.handle}
                            name={'developmentAdvice'}
                            text={section.text || section.developmentText}
                            saveInterval={saveInterval}
                            textareaPlaceholderText={i18n.report_edit_selection_development_advice_development_text_placeholder}
                        />
                    </div>
                </>
            }
        </section>
    </div>;
};
